import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@verosource/myhealth-web/src/App';
import config from './config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App incomingConfig={config} />);
